import {
  Indicator as CheckboxIndicator,
  Root as CheckboxRoot,
} from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';
import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

function Checkbox({
  className,
  ...props
}: ComponentProps<typeof CheckboxRoot>) {
  return (
    <CheckboxRoot
      className={cn(
        'peer size-4 shrink-0 rounded-[4px] border border-input shadow-xs outline-none transition-shadow focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:bg-input/30 dark:data-[state=checked]:bg-primary dark:aria-invalid:ring-destructive/40',
        className,
      )}
      data-slot='checkbox'
      {...props}
    >
      <CheckboxIndicator
        className='grid place-content-center text-current transition-none'
        data-slot='checkbox-indicator'
      >
        <CheckIcon className='size-3.5' />
      </CheckboxIndicator>
    </CheckboxRoot>
  );
}

export { Checkbox };
